"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46777],{

/***/ 250926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ InforFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const InforFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 7.00903C11.503 7.00903 11.1 7.41198 11.1 7.90903C11.1 8.40609 11.503 8.80903 12 8.80903C12.4971 8.80903 12.9 8.40609 12.9 7.90903C12.9 7.41198 12.4971 7.00903 12 7.00903ZM12 16.8408C11.5858 16.8408 11.25 16.505 11.25 16.0908L11.25 11.1817C11.25 10.7675 11.5858 10.4317 12 10.4317C12.4142 10.4317 12.75 10.7675 12.75 11.1817V16.0908C12.75 16.505 12.4142 16.8408 12 16.8408Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 846777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CustomHamperDesktopSlot": function() { return /* reexport */ CustomHamperDesktopSlot; },
  "CustomHamperMobileSlot": function() { return /* reexport */ CustomHamperMobileSlot; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(80912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../packages/utils/dist/object.es.js
var object_es = __webpack_require__(535820);
// EXTERNAL MODULE: ./contexts/HamperContext.tsx
var HamperContext = __webpack_require__(626650);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RefreshOutlined.es.js
var RefreshOutlined_es = __webpack_require__(802705);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./components/desktop/organisms/CustomHamper/hamperComponent/HamperTabs.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  a {\n    text-decoration: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-right: 0.5rem;\n  margin-top: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




const Wrapper = styled_es/* styled.div */.z.div(_templateObject());
const RightWrapper = styled_es/* styled.div */.z.div(_templateObject1());
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)(_templateObject2());
const HamperTabs = (_param)=>{
    var { onClickTab , onResetConfig , lsActiveTab  } = _param, props = _objectWithoutProperties(_param, [
        "onClickTab",
        "onResetConfig",
        "lsActiveTab"
    ]);
    const {} = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                        variant: index === lsActiveTab ? "primary" : "normal",
                        onClick: ()=>{
                            onClickTab && onClickTab(index);
                        },
                        children: [
                            (0,i18n.t)("Giỏ qu\xe0 tự chọn"),
                            " ",
                            index + 1
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                    variant: "primary",
                    onClick: onResetConfig,
                    children: [
                        (0,i18n.t)("Tạo lại"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshOutlined_es/* RefreshOutlined */.y, {
                            color: "white",
                            size: 16,
                            style: {
                                marginLeft: "0.5rem"
                            }
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/InforFilled.es.js
var InforFilled_es = __webpack_require__(250926);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(770024);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductName/ProductName.es.js
var ProductName_es = __webpack_require__(73586);
// EXTERNAL MODULE: ./helpers/hamper.ts
var hamper = __webpack_require__(282116);
;// CONCATENATED MODULE: ./components/desktop/organisms/CustomHamper/hamperComponent/HamperSummary.tsx
function HamperSummary_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HamperSummary_templateObject() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  padding: 1rem 2rem;\n  text-align: center;\n  margin-bottom: 16px;\n"
    ]);
    HamperSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HamperSummary_templateObject1() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  padding: 12px 8px;\n  background-color: #fff6ec;\n"
    ]);
    HamperSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HamperSummary_templateObject2() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  min-height: unset;\n  margin-left: 0.3rem;\n  color: rgb(235, 33, 1);\n  span {\n    font-size: 14px;\n  }\n"
    ]);
    HamperSummary_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  margin-top: 0.875rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  transition: 0.2s;\n  &.active {\n    transform: rotate(180deg);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 16px;\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 16px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  height: 1.5rem;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  padding: 8px;\n  margin-top: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n  :hover {\n    background-color: #f3f4f6;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  color: #82869e;\n  font-weight: 400;\n  font-size: 12px;\n  text-align: left;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  span {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 14px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}








const StyledCard = (0,emotion_styled_browser_esm["default"])(Card_es/* Card */.Z)(HamperSummary_templateObject());
const WarningCard = (0,emotion_styled_browser_esm["default"])(Card_es/* Card */.Z)(HamperSummary_templateObject1());
const Total = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(HamperSummary_templateObject2());
const HamperSummary_StyledButton = (0,emotion_styled_browser_esm["default"])(Button_Button_es/* Button */.z)(_templateObject3());
const HamperSummary = ()=>{
    const { increaseCurrentHamperQuantity , decreaseCurrentHamperQuantity , setCurrentHamperQuantity , priceSummary , priceAvailableHamper , allPriceSummary , handleBuyNowHamper , availableHamper , updateCurrentConfig , addHamper , removeHamper , minusHamper , onChangeQuantityHamper ,  } = (0,HamperContext/* useHamper */.h)();
    const { zaloUrl  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const countHamper = priceSummary.reduce((prev, cur)=>{
        return prev + cur.quantity;
    }, 0);
    const countAvailableHamper = availableHamper === null || availableHamper === void 0 ? void 0 : availableHamper.reduce((prev, cur)=>{
        return prev + cur.quantity;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,i18n.t)("Tổng gi\xe1 trị đơn h\xe0ng")
                    }),
                    !!allPriceSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        marginTop: "s16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    (0,i18n.t)("Giỏ qu\xe0 tự chọn"),
                                    " (",
                                    countHamper,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                price: allPriceSummary
                            })
                        ]
                    }),
                    !!priceAvailableHamper && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        marginTop: "s16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    (0,i18n.t)("Giỏ qu\xe0 g\xf3i sẵn"),
                                    " (",
                                    countAvailableHamper,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                price: priceAvailableHamper
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        color: "#f0f0f0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                                children: (0,i18n.t)("Tổng tạm t\xednh")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                price: allPriceSummary + (priceAvailableHamper || 0)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperSummary_StyledButton, {
                        variant: "primary",
                        block: true,
                        onClick: handleBuyNowHamper,
                        children: (0,i18n.t)("Mua ngay")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: zaloUrl,
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperSummary_StyledButton, {
                            variant: "default",
                            block: true,
                            children: (0,i18n.t)("Nhận tư vấn")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        color: "#f0f0f0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitle, {
                                children: [
                                    " ",
                                    (0,i18n.t)("Giỏ qu\xe0 tự chọn")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    "(",
                                    priceSummary.length,
                                    "/",
                                    hamper/* MAXIMUM_COUNT_HAMPER */.JQ,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    priceSummary.map((p, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamper, {
                            direction: "column",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    width: "100%",
                                    justify: "space-between",
                                    align: "middle",
                                    marginTop: "s16",
                                    children: [
                                        (0,i18n.t)("Giỏ qu\xe0 tự chọn"),
                                        " ",
                                        p.index + 1,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, {
                                            quantity: p.quantity,
                                            setQuantity: (newQuantity)=>setCurrentHamperQuantity(newQuantity, p.index),
                                            onMinus: p.quantity === 1 ? ()=>updateCurrentConfig({}, p.index) : ()=>decreaseCurrentHamperQuantity(p.index),
                                            onPlus: ()=>increaseCurrentHamperQuantity(p.index),
                                            min: 0,
                                            max: 999,
                                            color: "primary500"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsCollapse, {
                                    products: p.products
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    justify: "space-between",
                                    width: "100%",
                                    align: "middle",
                                    children: [
                                        (0,i18n.t)("Chi ph\xed dự kiến"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                            price: p.price
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        color: "#f0f0f0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                children: (0,i18n.t)("Giỏ qu\xe0 g\xf3i sẵn")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    "(",
                                    availableHamper.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    availableHamper.map((ah)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    justify: "start",
                                    marginTop: "s8",
                                    width: "100%",
                                    direction: "row",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                            width: 64,
                                            height: 64,
                                            src: ah === null || ah === void 0 ? void 0 : ah.imageUrl,
                                            border: true,
                                            borderRadius: 8,
                                            contain: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            direction: "column",
                                            justify: "start",
                                            width: "50%",
                                            paddingLeft: "s4",
                                            paddingRight: "s4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                                numberOfLine: 2,
                                                name: ah.name || (0,i18n.t)("T\xean sản phẩm đang được cập nhật")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            direction: "row",
                                            justify: "end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, {
                                                quantity: ah.quantity,
                                                setQuantity: (q)=>onChangeQuantityHamper(ah.sku, q),
                                                onMinus: ()=>ah.quantity === 1 ? removeHamper(ah.sku) : minusHamper(ah.sku),
                                                onPlus: ()=>addHamper(ah.sku),
                                                min: 0,
                                                max: 999,
                                                color: "primary500"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                    direction: "column",
                                    width: "100%",
                                    justify: "end",
                                    align: "end",
                                    marginTop: "s12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                                        price: ah.price * (ah.quantity || 1)
                                    })
                                })
                            ]
                        }, ah.sku);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningCard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "row",
                    align: "center",
                    justify: "start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InforFilled_es/* InforFilled */._, {
                            size: 24,
                            color: "#FAAD14"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                            width: "90%",
                            marginLeft: "s12",
                            direction: "column",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                level: 1,
                                weight: "regular",
                                color: "warning",
                                children: (0,i18n.t)("Đối với giỏ qu\xe0 tự chọn, mức gi\xe1 hiển thị chưa bao gồm khay v\xe0 nơ. Si\xeau thị sẽ li\xean hệ Qu\xfd kh\xe1ch để tư vấn v\xe0 x\xe1c nhận chi ph\xed trước khi đ\xf3ng g\xf3i")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const ProductsCollapse = (param)=>{
    let { products =[]  } = param;
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollapseHeader, {
                onClick: ()=>setShow(!show),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* SubTitle */.DK, {
                        color: "#82869e",
                        level: 4,
                        weight: "medium",
                        children: [
                            (0,i18n.t)("Xem chi tiết"),
                            " (",
                            products.length,
                            " ",
                            (0,i18n.t)("sản phẩm"),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDownOutlined, {
                        className: show ? "active" : "",
                        color: "textPrimary"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseContent, {
                className: show ? "active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
                    direction: "column",
                    children: products.map((product, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductItem, {
                            justify: "start",
                            marginTop: "s8",
                            width: "100%",
                            direction: "row",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    width: 40,
                                    height: 40,
                                    src: product === null || product === void 0 ? void 0 : product.imageUrl,
                                    border: true,
                                    borderRadius: 8,
                                    contain: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: "column",
                                    justify: "start",
                                    width: "70%",
                                    paddingLeft: "s4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                            name: product.name || (0,i18n.t)("T\xean sản phẩm đang được cập nhật")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SKU, {
                                            children: [
                                                "SL: ",
                                                product.quantity
                                            ]
                                        })
                                    ]
                                }),
                                product.quantity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    width: "30%",
                                    paddingLeft: "s4",
                                    justify: "end",
                                    align: "middle",
                                    children: product && product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                                        price: product.price.latestPrice * (product.quantity || 1)
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
const StyledDownOutlined = (0,emotion_styled_browser_esm["default"])(DownOutlined_es/* DownOutlined */.T)(_templateObject4());
const Collapse = emotion_styled_browser_esm["default"].div(_templateObject5());
const CollapseHeader = emotion_styled_browser_esm["default"].div(_templateObject6());
const CollapseContent = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  gap: 0.25rem;\n  &.active {\n    margin-top: ".concat(theme === null || theme === void 0 ? void 0 : theme.spacing.s12, ";\n    height: auto;\n  }\n");
});
const StyledFlex = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject7());
const StyledHamper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject8());
const StyledProductItem = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject9());
const StyledProductName = (0,emotion_styled_browser_esm["default"])(ProductName_es/* ProductName */.r)((param)=>{
    let { numberOfLine =1  } = param;
    return "\n  overflow: hidden;\n  text-align: left;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: ".concat(numberOfLine, ";\n");
});
const SKU = emotion_styled_browser_esm["default"].span(_templateObject10());
const StyledPrice = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(_templateObject11());
const StyledTitle = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject12());
const StyledContent = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject13());

// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./constants/hamper.ts
var constants_hamper = __webpack_require__(467327);
// EXTERNAL MODULE: ./constants/buildpc.ts
var buildpc = __webpack_require__(360339);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./helpers/buildpc.ts
var helpers_buildpc = __webpack_require__(329040);
// EXTERNAL MODULE: ./hooks/useHamperProducts.ts
var useHamperProducts = __webpack_require__(961247);
// EXTERNAL MODULE: ./modules/search-page/shared/helpers.ts
var helpers = __webpack_require__(774608);
// EXTERNAL MODULE: ./components/desktop/organisms/BuildPC/BuildPcModal.tsx
var BuildPcModal = __webpack_require__(468418);
;// CONCATENATED MODULE: ./components/desktop/organisms/CustomHamper/hamperComponent/HamperModal.tsx
function HamperModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HamperModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HamperModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HamperModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HamperModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HamperModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











const HamperModal = (props)=>{
    const { visible , onClose , collectionSlug , hamperItemKey  } = props;
    const { 0: priceFilterValue , 1: setPriceFilterValue  } = (0,react.useState)();
    const { 0: keyword , 1: setKeyword  } = (0,react.useState)("");
    const { 0: activeOptions , 1: setActiveOptions  } = (0,react.useState)([]);
    const { 0: activeSortOption , 1: setActiveSortOption  } = (0,react.useState)();
    const { 0: currentPage , 1: setCurrentPage  } = (0,react.useState)(1);
    (0,react.useEffect)(()=>{
        setCurrentPage(1);
    }, [
        keyword
    ]);
    const [sort, order] = activeSortOption ? (0,helpers/* extractSortQuery */.To)(activeSortOption.optionCode) : [
        undefined,
        undefined
    ];
    // fetch filter block data
    const { filter , loading: filterLoading  } = (0,useHamperProducts/* useHamperProducts */.o)({
        slug: collectionSlug,
        returnFilterable: [
            "FILTER_TYPE_ATTRIBUTE",
            "FILTER_TYPE_BRAND",
            "FILTER_TYPE_PRICE",
            "FILTER_TYPE_CLEARANCE", 
        ],
        pageSize: 1
    });
    // fetch product list
    const { products , pagination , loading: productLoading ,  } = (0,useHamperProducts/* useHamperProducts */.o)({
        slug: collectionSlug,
        query: keyword,
        sorting: (0,discovery/* convertToPayloadSorting */.EN)(sort, order),
        filter: (0,dist_index_es.cleanObject)(HamperModal_objectSpreadProps(HamperModal_objectSpread({}, (0,helpers_buildpc/* convertFilter */.pu)(activeOptions)), {
            priceGte: priceFilterValue === null || priceFilterValue === void 0 ? void 0 : priceFilterValue.gte,
            priceLte: priceFilterValue === null || priceFilterValue === void 0 ? void 0 : priceFilterValue.lte
        })),
        pageSize: constants_hamper/* HAMPER_PAGE_SIZE */.Qi,
        page: currentPage
    }, hamperItemKey);
    const filters = (0,react.useMemo)(()=>{
        return !!filter ? (0,discovery/* convertDiscoveryFilter */.px)(filter) : [];
    }, [
        filter
    ]);
    const displayFilters = (0,react.useMemo)(()=>{
        return (0,helpers_buildpc/* getDisplayFilter */.Ou)(filters);
    }, [
        filters
    ]);
    const priceFilter = (0,react.useMemo)(()=>{
        return (0,helpers/* cookFilterPrice */.kr)(filter === null || filter === void 0 ? void 0 : filter.priceLte, filter === null || filter === void 0 ? void 0 : filter.priceGte);
    }, [
        filter === null || filter === void 0 ? void 0 : filter.priceLte,
        filter === null || filter === void 0 ? void 0 : filter.priceGte
    ]);
    const onSortOptionSelected = (sortOption)=>{
        if (sortOption.optionCode === (activeSortOption === null || activeSortOption === void 0 ? void 0 : activeSortOption.optionCode)) {
            setActiveSortOption(undefined);
        } else {
            setActiveSortOption(sortOption);
        }
    };
    const onClickFilterOption = (option)=>{
        const optionIndex = activeOptions.findIndex((opt)=>opt.filterCode === option.filterCode && opt.filterId === option.filterId && opt.optionId === option.optionId);
        if (optionIndex > -1) {
            setActiveOptions((prev)=>prev.filter((_, index)=>index !== optionIndex));
        } else {
            setActiveOptions((prev)=>[
                    ...prev,
                    option
                ]);
        }
    };
    const onClickSearch = (keyword)=>{
        setKeyword(keyword);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
        isLoading: filterLoading || productLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcModal/* ProductSelectModalComponent */.r, {
            visible: visible,
            onClose: ()=>{
                onClose === null || onClose === void 0 ? void 0 : onClose();
                setActiveOptions([]);
                setPriceFilterValue(undefined);
                setActiveSortOption(undefined);
            },
            listProducts: products,
            filters: displayFilters,
            pagination: pagination || {
                totalItems: 0,
                totalPages: 0
            },
            filterPrice: HamperModal_objectSpreadProps(HamperModal_objectSpread({}, priceFilter), {
                value: priceFilterValue || buildpc/* DEFAULT_PRICE_FILTER */.DT
            }),
            currentPage: currentPage,
            onSortByPrice: (gte, lte)=>setPriceFilterValue({
                    gte,
                    lte
                }),
            onPageChange: (page)=>setCurrentPage(page),
            activeSortOption: activeSortOption,
            activeOptions: activeOptions,
            onSortOptionSelected: onSortOptionSelected,
            onClearFilter: ()=>setActiveOptions([]),
            onClickFilterOption: onClickFilterOption,
            onClickSearch: onClickSearch,
            isLoading: filterLoading || productLoading,
            title: (0,i18n.t)("Chọn sản phẩm"),
            isUsingHamper: true,
            hamperItemKey: hamperItemKey
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcNumberStepper/BuildPcNumberStepper.es.js
var BuildPcNumberStepper_es = __webpack_require__(260613);
;// CONCATENATED MODULE: ./components/desktop/organisms/CustomHamper/hamperComponent/HamperItem.tsx
function HamperItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HamperItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HamperItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HamperItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HamperItem_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HamperItem_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function HamperItem_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = HamperItem_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function HamperItem_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function HamperItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HamperItem_templateObject() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  transition: box-shadow 0.2s ease-in-out;\n  &:hover {\n    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);\n  }\n"
    ]);
    HamperItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HamperItem_templateObject1() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: center;\n"
    ]);
    HamperItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HamperItem_templateObject2() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  color: unset;\n  text-decoration: unset;\n"
    ]);
    HamperItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HamperItem_templateObject3() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  color: #82869e;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    HamperItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HamperItem_templateObject4() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  height: 32px;\n  width: 105px;\n  padding: 0;\n"
    ]);
    HamperItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HamperItem_templateObject5() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  min-height: auto;\n"
    ]);
    HamperItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HamperItem_templateObject6() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  font-size: 16px;\n"
    ]);
    HamperItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




const HamperItem_StyledCard = (0,emotion_styled_browser_esm["default"])(Card_es/* Card */.Z)(HamperItem_templateObject());
const NameWrapper = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)(HamperItem_templateObject1());
const Anchor = emotion_styled_browser_esm["default"].a(HamperItem_templateObject2());
const HamperItem_SKU = emotion_styled_browser_esm["default"].span(HamperItem_templateObject3());
const HamperItem_StyledButton = (0,emotion_styled_browser_esm["default"])(Button_Button_es/* Button */.z)(HamperItem_templateObject4());
const HamperItem_StyledPrice = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(HamperItem_templateObject5());
const HamperItem_StyledTitle = (0,emotion_styled_browser_esm["default"])(index_es/* Title */.Dx)(HamperItem_templateObject6());
const HamperItem = (_param)=>{
    var { title , products =[] , icon ="" , onClick , onIncrease , onDecrease , setQuantity  } = _param, props = HamperItem_objectWithoutProperties(_param, [
        "title",
        "products",
        "icon",
        "onClick",
        "onIncrease",
        "onDecrease",
        "setQuantity"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamperItem_StyledCard, HamperItem_objectSpreadProps(HamperItem_objectSpread({}, props), {
        padding: "s16",
        marginBottom: "s16",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledTitle, {
                children: title
            }),
            !products.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                marginTop: "s12",
                justify: "space-between",
                align: "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                        border: "1px solid border",
                        borderRadius: "l",
                        padding: "s4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            width: 68,
                            height: 68,
                            src: icon,
                            border: true,
                            borderRadius: 8,
                            contain: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledButton, {
                        onClick: onClick,
                        variant: "primary",
                        children: (0,i18n.t)("Chọn")
                    })
                ]
            }),
            products === null || products === void 0 ? void 0 : products.map((product, index)=>{
                var ref, ref1, ref2, ref3;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            width: "100%",
                            justify: "space-between",
                            marginTop: "s12",
                            align: "middle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    width: "70%",
                                    justify: "start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                                            border: "1px solid border",
                                            borderRadius: "l",
                                            padding: "s4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                                width: 68,
                                                height: 68,
                                                src: (product === null || product === void 0 ? void 0 : product.imageUrl) || icon,
                                                onClick: ()=>{
                                                    if (!product) onClick === null || onClick === void 0 ? void 0 : onClick();
                                                },
                                                border: true,
                                                borderRadius: 8,
                                                contain: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NameWrapper, {
                                            marginLeft: "s12",
                                            width: "70%",
                                            children: product ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                                                        href: typeof ((ref = product.link) === null || ref === void 0 ? void 0 : ref.as) === "string" ? (ref1 = product.link) === null || ref1 === void 0 ? void 0 : ref1.as : (ref2 = product.link) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.as) === null || ref3 === void 0 ? void 0 : ref3.pathname,
                                                        rel: "noreferrer noopener",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName_es/* ProductName */.r, {
                                                            name: product.name || (0,i18n.t)("T\xean sản phẩm đang được cập nhật")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamperItem_SKU, {
                                                        children: [
                                                            "SKU: ",
                                                            product.sellerSku
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: (0,i18n.t)("Vui l\xf2ng chọn sản phẩm")
                                            })
                                        })
                                    ]
                                }),
                                product.quantity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    width: "30%",
                                    justify: "end",
                                    align: "middle",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            direction: "column",
                                            width: "60%",
                                            height: "100%",
                                            children: (product === null || product === void 0 ? void 0 : product.quantity) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcNumberStepper_es/* BuildPcNumberStepper */.F, {
                                                onIncrease: ()=>{
                                                    return onIncrease === null || onIncrease === void 0 ? void 0 : onIncrease(product.sku);
                                                },
                                                onDecrease: ()=>{
                                                    return onDecrease === null || onDecrease === void 0 ? void 0 : onDecrease(product.sku, product.quantity);
                                                },
                                                setValue: (value)=>{
                                                    return setQuantity === null || setQuantity === void 0 ? void 0 : setQuantity(value, product.sku);
                                                },
                                                value: product.quantity
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            direction: "column",
                                            justify: "start",
                                            align: "start",
                                            width: "40%",
                                            height: "100%",
                                            children: product && product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledPrice, {
                                                price: product.price.latestPrice,
                                                discount: product.price.discountPercent,
                                                listedPrice: product.price.supplierRetailPrice
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, product.sku),
                        !!product.quantity && index === products.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                            width: "100%",
                            justify: "end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledButton, {
                                onClick: onClick,
                                variant: "primary",
                                children: (0,i18n.t)("Chọn th\xeam")
                            })
                        })
                    ]
                });
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/desktop/organisms/CustomHamper/CustomHamper.tsx
function CustomHamper_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomHamper_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomHamper_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CustomHamper_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CustomHamper_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CustomHamper_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CustomHamper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CustomHamper_templateObject() {
    const data = CustomHamper_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    CustomHamper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const CustomHamper = ()=>{
    const { 0: selectedBomItem , 1: setSelectedBomItem  } = (0,react.useState)();
    const { bomMapping  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { loading , hamperData , changeActiveConfig , updateCurrentConfig , currentHamperConfig , hamperDetailProducts , increaseHamperItemQuantity , decreaseHamperItemQuantity , removeHamperItem , setHamperItemQuantity ,  } = (0,HamperContext/* useHamper */.h)();
    const bomMappingKeys = (0,react.useMemo)(()=>{
        return !!bomMapping && !(0,object_es/* isEmptyObject */.Q)(bomMapping) ? Object.keys(bomMapping) : [];
    }, [
        bomMapping
    ]);
    const onClickBomItem = (hamperItem)=>{
        setSelectedBomItem(hamperItem);
    };
    if ((0,object_es/* isEmptyObject */.Q)(bomMapping) || !bomMapping) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
        padding: "s0",
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading_es/* Loading */.g, {
            isLoading: loading,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    marginTop: "s16",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            width: "66%",
                            id: "hamper-item-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperTabs, {
                                    lsActiveTab: hamperData.activeIndex,
                                    onClickTab: (index)=>{
                                        changeActiveConfig(index);
                                        (0,helper_es/* trackCustomEvent */.I)("changeHamperConfig", {
                                            action: "click",
                                            category: "custom_hamper",
                                            value: index + 1
                                        });
                                    },
                                    onResetConfig: ()=>updateCurrentConfig({})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    marginTop: "s32",
                                    children: bomMappingKeys.map((customHamper)=>{
                                        var ref, ref1;
                                        const selectedHamper = currentHamperConfig[customHamper] || [];
                                        const hampers = hamperDetailProducts.products.filter((hamper)=>{
                                            return selectedHamper.map((p)=>p.sku).includes(hamper.sku);
                                        }).map((p)=>{
                                            var ref;
                                            return CustomHamper_objectSpreadProps(CustomHamper_objectSpread({}, p), {
                                                quantity: ((ref = selectedHamper.find((h)=>h.sku === p.sku)) === null || ref === void 0 ? void 0 : ref.quantity) || 1
                                            });
                                        });
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHamperItem, {
                                            title: bomMapping === null || bomMapping === void 0 ? void 0 : (ref = bomMapping[customHamper]) === null || ref === void 0 ? void 0 : ref.name,
                                            icon: bomMapping[customHamper].icon,
                                            products: !!hampers && !!Array.isArray(hampers) ? hampers : [],
                                            onIncrease: (sku)=>increaseHamperItemQuantity(customHamper, sku),
                                            onDecrease: (sku, quantity)=>{
                                                quantity === 1 ? removeHamperItem(customHamper, sku) : decreaseHamperItemQuantity(customHamper, sku);
                                            },
                                            setQuantity: (value, sku)=>{
                                                setHamperItemQuantity(customHamper, value, sku);
                                            },
                                            onClick: ()=>{
                                                return onClickBomItem(bomMapping === null || bomMapping === void 0 ? void 0 : bomMapping[customHamper]);
                                            }
                                        }, bomMapping === null || bomMapping === void 0 ? void 0 : (ref1 = bomMapping[customHamper]) === null || ref1 === void 0 ? void 0 : ref1.type);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            width: "33%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperSummary, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperModal, {
                    collectionSlug: (selectedBomItem === null || selectedBomItem === void 0 ? void 0 : selectedBomItem.slug) || "",
                    visible: !!selectedBomItem,
                    onClose: ()=>setSelectedBomItem(undefined),
                    hamperItemKey: (selectedBomItem === null || selectedBomItem === void 0 ? void 0 : selectedBomItem.type) || ""
                })
            ]
        })
    });
};
const StyledHamperItem = (0,emotion_styled_browser_esm["default"])(HamperItem)(CustomHamper_templateObject());

;// CONCATENATED MODULE: ./modules/page-builder/slots/CustomHamper/CustomHamperDesktopSlot.tsx


const CustomHamperDesktopSlot = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHamper, {});
};

// EXTERNAL MODULE: ./components/mobile/organisms/CustomHamper/CustomHamper.tsx + 5 modules
var CustomHamper_CustomHamper = __webpack_require__(792239);
;// CONCATENATED MODULE: ./modules/page-builder/slots/CustomHamper/CustomHamperMobileSlot.tsx


const CustomHamperMobileSlot = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHamper_CustomHamper/* CustomHamper */.l, {});
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/CustomHamper/index.ts




/***/ })

}]);